<template>
    <cod-dialog
        ref="dialog"
        :show.sync="showDialog"
        :drawer="drawer"
        :max-width="report && report.width ? report.width : undefined"
        color="primary"
    >
        <!-- Navigation Drawer -->
        <div slot="drawer" class="drawer-wrapper">
            <div v-if="drawer === 'report'">
                <v-toolbar
                    class="wfull"
                    color="#1565c0"
                    absolute
                    dark
                    flat
                >
                    <v-btn
                        icon
                        @click="closeReport"
                    >
                        <v-icon>fal fa-times</v-icon>
                    </v-btn>

                    <v-toolbar-title>
                        {{ !report ? $t('reports.heading') : $t(`reports.${report.type}`) }}
                    </v-toolbar-title>

                    <v-spacer />

                    <v-btn
                        text
                        dark
                        class="minw100"
                        @click="togglePrint"
                    >
                        <v-icon class="mr-3">fal fa-print</v-icon>
                        {{ $t('general.print') }}
                    </v-btn>
                </v-toolbar>

                <div
                    class="drawer-content"
                    :class="{ 'report-content': !!report }"
                >
                    <v-slide-y-transition>
                        <div
                            v-if="initPrint && enableReceiptPrinter"
                            class="d-flex align-center flex-column"
                        >
                            <v-checkbox
                                v-model="useReceiptPrinter"
                                :label="$t('general.print_on_receipt_printer')"
                            />

                            <div>
                                <v-btn
                                    class="mx-2"
                                    color="primary"
                                    outlined
                                    @click="initPrint = false"
                                >
                                    <v-icon class="mr-3">fal fa-times</v-icon>
                                    {{ $t('general.cancel') }}
                                </v-btn>

                                <v-btn
                                    class="mx-2"
                                    color="primary"
                                    depressed
                                    @click="printReport(useReceiptPrinter)"
                                >
                                    <v-icon class="mr-3">fal fa-check</v-icon>
                                    {{ $t('general.print') }}
                                </v-btn>
                            </div>
                        </div>
                    </v-slide-y-transition>

                    <div class="px-5 py-2" v-html="reportHtml"></div>
                </div>
            </div>
        </div>

        <!-- Header -->
        <div class="header" slot="header">
            {{ $tc('general.report', 2) }}
        </div>

        <!-- Content -->
        <div class="reports-content" slot="content">
            <reports @create="onReportCreate" />
        </div>
    </cod-dialog>
</template>

<script>
import CodDialog from '@/components/CodDialog';
import Reports from '@/views/shared/components/Reports';

export default {
    components: {
        CodDialog,
        Reports
    },

    props: {
        show: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            showDialog: false,
            drawer: null,

            report: null,
            reportHtml: null,

            initPrint: false,
            receiptPrinter: null,
            useReceiptPrinter: false,
        }
    },

    watch: {
        show(val) {
            this.showDialog = val;
            this.drawer = null;
            this.report = null;
            this.reportHtml = null;

            if(val) {
                this.useReceiptPrinter = this.enableReceiptPrinter
                this.receiptPrinter = this.$printService.getAssignedPrinter('receipt')
            }

            setTimeout(() => { this.drawer = null }, val ? 0 : 1500);
        },

        showDialog(val) {
            this.$emit('update:show', val);
        },
    },

    computed: {
        enableReceiptPrinter() {
            return !!this.receiptPrinter && this.device.platform !== 'web'
        },
    },

    methods: {
        togglePrint() {
            if(!this.enableReceiptPrinter) {
                this.printReport(false)
                return
            }

            if(this.device.platform === 'android') {
                this.printReport(true)
                return
            }

            this.initPrint = !this.initPrint
        },

        printReport(useReceiptPrinter) {
            this.initPrint = false

            this.$printService.printReport(this.report, {
                type: this.report.type,
                choosePrinter: !useReceiptPrinter
            })
        },

        onReportCreate(data) {
            this.report = data.report;
            this.reportHtml = this.report.getPrintable().toHtml('report').join('');
            this.drawer = 'report';
        },

        closeReport() {
            this.report = null;
            this.drawer = null;
        }
    }
};
</script>

<style lang="scss" scoped>
.header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.drawer-wrapper {
    height: 100%;
    width: 100%;

    .drawer-content {
        max-height: 100%;
        overflow-y: auto;
        padding: 64px 20px 16px 20px;
        position: relative;
        height: 100%;

        &.report-content {
            padding: 64px 0 16px 0;
        }
    }
}

.reports-content {
    padding: 20px;
    min-height: 520px;

    .print-btn {
        position: absolute;
        bottom: 20px;
        left: 20px;
        right: 20px;
    }
}
</style>
